import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMConst from 'lib/SMConst';
import SMOReservationEditViewBlockSetting from './SMOReservationEditViewBlockSetting';
import SMReservationHelper from 'components/helpers/SMReservationHelper';
import SMReservationStatusResource from 'resources/SMReservationStatusResource';
import SMReservationChannelTypeResource from 'resources/SMReservationChannelTypeResource';
import SMRoomResource from 'resources/SMRoomResource';
import SMReservationResource from 'resources/SMReservationResource';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMReservationEditView from 'components/dashboard/shared/SMReservationEditView';
import SMReservationEditViewSpace from 'components/dashboard/shared/SMReservationEditViewSpace';

class SMOReservationEditView extends SMReservationEditView {

  constructor(props) {
    super(props);
    
    let initialEndedDate = null;
    if (this.props.initialEndedDate) {
      initialEndedDate = new Date(this.props.initialEndedDate);
      initialEndedDate.setDate(initialEndedDate.getDate() + 1);
    }
    this.state = {
      owner: this.props.owner.attributes,
      spaceId: this.props.initialSpaceId,
      roomId: this.props.initialRoomId,
      room: null,
      plan: null,
      reservation: { status: SMConst.ReservationStatus.Confirmed },
      errors: [],
      isChangedPrice: false,
      statuses: [],
      channelTypes: [],
      startedDate: this.props.initialStartedDate ? new Date(this.props.initialStartedDate) : null,
      endedDate: initialEndedDate,
      startedHour: null,
      endedHour: null,
      stayCheckinAt: this.props.initialStayCheckinAt,
      stayCheckoutAt: this.props.initialStayCheckoutAt,
      saveButtonStatus: true,
    };

    this.handleClickSubmitButton = this.handleClickSubmitButton.bind(this);
    this.handleClickCancelButton = this.handleClickCancelButton.bind(this);
    this.deleteItemDidClick = this.deleteItemDidClick.bind(this);
  }

  componentDidMount() {
    $(this.refs.form).startLoading();
    if (this.state.statuses.length == 0) {
      SMReservationStatusResource.getReservationStatuses({ type: 'manual_reservation' }, function(statuses, error, xhr) {
        this.setState({ statuses: statuses });
      }.bind(this));
    }

    if (this.state.channelTypes.length == 0) {
      SMReservationChannelTypeResource.getReservationChannelTypes({}, (channelTypes, error, xhr)=> {
        this.setState({ channelTypes: channelTypes });
      });
    }

    if (SMReservationHelper.isOwnerDirect(this.props.mediator)) {
      this.setState(function(previousState, currentProps) {
        previousState.reservation.method = SMConst.ReservationMethod.Reservation;
        return {
          reservation: previousState.reservation,
        };
      });
    }

    if (this.state.roomId) {
      SMRoomResource.getRoom(this.state.roomId, (data, error, xhr)=> {
        this.setState(function (previousState, currentProps) {
          previousState.reservation.room = data;
          return {
            reservation: previousState.reservation,
            space: data.space,
            room: data,
            plan: data,
          };
        });
      });
    }

    if (this.props.reservationId) {
      SMOwnerResource.getReservation(this.state.owner.username, this.props.reservationId, (reservation, error, xhr)=> {
        // APIから時刻を取得
        // JSTの時間をISO表記で送られるため、Date型に直すと+9時間進む
        let startedAt = reservation.started_at ? new Date(reservation.started_at) : null;
        let endedAt = reservation.ended_at ? new Date(reservation.ended_at) : null;
        let stayCheckinAt = reservation.stay_checkin_at ? new Date(reservation.stay_checkin_at) : null;
        let stayCheckoutAt = reservation.stay_checkout_at ? new Date(reservation.stay_checkout_at) : null;

        // +9時間進んだ時刻を戻す
        let changedStartedAt = startedAt ? new Date(startedAt.getTime() - reservation.room.space.utc_offset * 1000) : null;
        let changedEndedAt = endedAt ? new Date(endedAt.getTime() - reservation.room.space.utc_offset * 1000) : null;
        let changedStayCheckinAt = stayCheckinAt ? new Date(stayCheckinAt.getTime() - reservation.room.space.utc_offset * 1000) : null;
        let changedStayCheckoutAt = stayCheckoutAt ? new Date(stayCheckoutAt.getTime() - reservation.room.space.utc_offset * 1000) : null;

        // 開始日時の日と時刻を分離
        let startedDate = changedStartedAt ? this.beginningOfDate(changedStartedAt) : null;
        let startedHour = changedStartedAt ? changedStartedAt.getHours() : null;

        // 終了日時の日と時刻を分離
        let endedDate = changedEndedAt ? this.beginningOfDate(changedEndedAt) : null;
        let endedHour = changedEndedAt ? changedEndedAt.getHours() : null;
        
        if (this.props.method == SMConst.ReservationMethod.Inquiry && endedDate) endedDate.setDate(endedDate.getDate() + 1);

        let plan = reservation.plan_id == 0 ? reservation.room : reservation.plan;
        if (plan && (plan.price_calc_type == SMConst.PriceCalcType.PerPerson || plan.rent_type == SMConst.RentType.Stay)) {
          if (!reservation.number_of_guests) reservation.number_of_guests = 1;
        } else {
          if (!reservation.capacity) reservation.capacity = 10;
        }

        this.setState({
          reservation: reservation,
          spaceId: reservation.room.space.username,
          roomId: reservation.room.uid,
          space: reservation.room.space,
          room: reservation.room,
          plan: reservation.plan_id == 0 ? reservation.room : reservation.plan,
          isChangedPrice: !!(reservation.billing && reservation.billing.total_changed_amount != null),
          startedDate: startedDate,
          startedHour: startedHour,
          endedDate: endedDate,
          endedHour: endedHour,
          stayCheckinAt: changedStayCheckinAt,
          stayCheckoutAt: changedStayCheckoutAt,
        });

        if (reservation.method == SMConst.ReservationMethod.Inquiry && reservation.started_at && reservation.ended_at) {
          setTimeout(()=>{
            this.updateResource([], true);
          }, 500);
        } else {
          $(this.refs.form).stopLoading();
        }
      });
    } else {
      this.setState({
        plan: {
          plan_id: 0,
          mediator: SMConst.ReservationMediator.OwnerDirect
        }
      });
      $(this.refs.form).stopLoading();
    }
  }

  updateResource(arrayValues, dryrun, changePoint) {
    let formData = new FormData();
    let queries = { mediator: this.props.mediator };
    let responseHandler = (reservation, error, xhr) => {
      if (xhr.status == 200 || xhr.status == 201) {
        if (dryrun) {
          if (!dryrun) $(this.refs.form).stopLoading();

          if (reservation.plan_id != this.state.reservation.plan_id) {
            reservation.billing.total_amount_text = null;
          }

          this.setState({
            reservation: reservation,
            errors: [],
          });
          $(this.refs.form).stopLoading();
        } else {
          if (xhr.responseJSON.unapproved_reservation != null) window.alert(I18n.t("dashboard.text_000050"));
          location.href = Routes.owner_dashboard_reservation_path(this.state.owner.username, reservation.uid);
        }
      } else if (xhr.status == 400) {
        $(this.refs.form).stopLoading();
        let errors = xhr.responseJSON.errors;
        if (dryrun) {
          errors = [];
          for (let i = 0; i < xhr.responseJSON.errors.length; i++) {
            if (xhr.responseJSON.errors[i].field.search(/^reservation_user/) == -1) {
              errors.push(xhr.responseJSON.errors[i]);
            }
          }
        }
        reservation = JSON.parse(xhr.responseText).resource;
        errors = this.uniqueErrorMessage(errors);

        this.setState({
          reservation: reservation,
          errors: errors
        });
      } else {
        $(this.refs.form).stopLoading();
      }

      this.setState({
        saveButtonStatus: true
      });
    };

    let names = [];
    for (let i = 0; i < arrayValues.length; i++) {
      let value = arrayValues[i];
      formData.append(value[0], value[1]);
      names.push(value[0]);
    }

    if (dryrun) queries.dryrun = dryrun;

    // 更新系以外のパラメータを設定
    if (names.indexOf('owner_id') == -1) formData.append('owner_id', this.state.owner.id);
    this.setOtherFormData(names, formData, changePoint);

    if (this.state.reservation.id) {
      SMOwnerResource.updateReservation(
        this.state.owner.username,
        this.state.reservation.id,
        formData,
        queries,
        responseHandler
      );
    } else {
      SMOwnerResource.postReservation(this.state.owner.username, formData, queries, responseHandler);
    }

    if (!dryrun) $(this.refs.form).startLoading();
  }

  // event observer
  handleClickCancelButton(e) {
    if (this.state.reservation.uid) {
      location.href = $(ReactDOM.findDOMNode(e.currentTarget)).data('href') + '/' + this.state.reservation.uid;
    } else {
      location.href = Routes.owner_dashboard_path(this.state.owner.username);
    }
  }

  handleClickSubmitButton(e) {
    e.preventDefault();
    if (this.props.method == SMConst.ReservationMethod.Inquiry) {
      this.trackPageEvent('od submit change_inquiry_to_reservation');
    } else {
      if (this.props.action == 'edit') {
        this.trackPageEvent('od submit edit_reservation');
      } else {
        this.trackPageEvent('od submit manual_reservation');
      }
    }

    this.setState({
      saveButtonStatus: false
    });
    this.updateResource([], false);
  }

  deleteItemDidClick(e) {
    e.preventDefault();
    if (window.confirm(I18n.t("dashboard.notice_000003"))) {
      SMOwnerResource.deleteReservation(this.state.owner.username, this.state.reservation.id, {}, function(data, error, xhr) {
        if (xhr.status == 204) {
          location.href = Routes.owner_dashboard_reservations_path(this.state.owner.username);
        }
      }.bind(this));
    }
  }

  renderReservation() {
    return (
      <div>
        <h3 className="dashboard-title2 mb20">予約内容</h3>
        <table ref='reservationTable' className="dashboard-form-table mb50">
          <tbody>
          {this.props.controller == 'owners/dashboard/reservations' ? this.renderSpace() : null}
          {this.renderPlans()}
          {this.isStayReservation() ? this.renderStaySchedules() : this.renderSchedules()}
          {this.isStayReservation() ? this.renderCheckInTime() : null}
          {this.canDisplayNumberOfGuests() ? this.renderHeadCount() : this.renderCapacity()}
          {this.renderOptionItems()}
          {this.renderOptionFoods()}
          {this.renderStatus()}
          {this.renderPrice(true)}
          {this.renderEventType()}
          {this.renderUseType()}
          {this.renderNote()}
          </tbody>
        </table>
      </div>
    );
  }

  renderCustomer() {
    return (
      <div>
        <h3 className="dashboard-title2 mb20">お客様情報</h3>
        <table className="dashboard-form-table mb80">
          <tbody>
          {this.renderTel()}
          {this.renderName()}
          {this.renderCorpName()}
          {this.renderEmail()}
          {this.renderGuestName()}
          {this.renderPaymentPeriod(true)}
          {this.renderChannelType()}
          </tbody>
        </table>
      </div>
    );
  }

  renderBlockSetting() {
    if (this.props.controller == 'owners/dashboard/blocks' && this.props.action == 'new') {
      return (
        <SMOReservationEditViewBlockSetting
          reservation={this.state.reservation}
          ownerId={this.state.owner.username}
          spaceId={this.state.spaceId}
          roomId={this.state.roomId}
          delegate={this} />
      );
    } else {
      return null;
    }
  }

  renderSpace() {
    return (
      <tr>
        <th>会場・スペース名<span className="icon-form icon-form__required dashboard-form-table__icon">必須</span></th>
        <SMReservationEditViewSpace
          reservation={this.state.reservation}
          ownerId={this.state.owner.username}
          spaceId={this.state.spaceId}
          roomId={this.state.roomId}
          isUser={false}
          errors={this.state.errors}
          delegate={this} />
      </tr>
    );
  }

  renderCalendarLink() {
    return (
      <p className="mt10">
        <a href={Routes.owner_dashboard_calendars_path(this.state.owner.username, {
          space_id: this.state.spaceId,
          room_id: this.state.roomId
        })} target="_blank" className="link-hover-border">予約カレンダーを確認</a>
      </p>
    );
  }

  render() {
    let deleteItemBtn;
    if (this.state.reservation.id && this.state.reservation.mediator == SMConst.ReservationMediator.OwnerDirect) {
      deleteItemBtn =
        <a href="#" onClick={this.deleteItemDidClick} className="button button-gray dashboard-title__button"><i
          className="fa fa-trash-o mr5"></i>削除する</a>;
    }

    let label, submitLabel;
    if (this.props.mediator == SMConst.ReservationMediator.OwnerDirect) {
      if (this.props.action == 'edit') {
        label = I18n.t("dashboard.label_000165");
        submitLabel = I18n.t("dashboard.label_000164");
      } else {
        label = I18n.t("dashboard.label_000163");
        submitLabel = I18n.t("dashboard.label_000161");
      }
    } else {
      switch (this.state.reservation.method) {
        case SMConst.ReservationMethod.Inquiry:
          label = I18n.t("dashboard.label_000147");
          submitLabel = I18n.t("dashboard.label_000148");
          break;
        case SMConst.ReservationMethod.Reservation:
        default:
          if (this.props.action == 'edit') {
            label = I18n.t("dashboard.label_000149");
            submitLabel = I18n.t("dashboard.label_000151");
          } else {
            label = I18n.t("dashboard.label_000150");
            submitLabel = I18n.t("dashboard.label_000120");
          }
          break;
      }
    }

    return (
      <div className="dashboard-container clearfix mb30">
        <div className="dashboard-maincol" ref="formContent">
          <h2 className="dashboard-title mb30">{label}{deleteItemBtn}</h2>

          <form ref='form'>
            <input type='hidden' name='owner_id' value={this.state.owner.username} />

            {this.renderBlockSetting()}
            {this.renderReservation()}
            {this.renderCustomer()}

            <div className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
              <input data-href={Routes.owner_dashboard_reservations_path(this.state.owner.username)}
                     className="button-gray maincol-buttonarea__button"
                     type="button"
                     value={I18n.t("dashboard.label_000152")} onClick={this.handleClickCancelButton} />
              <input data-href={Routes.owner_dashboard_reservations_path(this.state.owner.username)}
                     className={this.canSubmitButton() ? "button-green maincol-buttonarea__button" : "button-disabled maincol-buttonarea__button"}
                     disabled={!this.canSubmitButton()}
                     type="submit"
                     value={submitLabel}
                     onClick={this.handleClickSubmitButton} />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default SMOReservationEditView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOReservationEditView.jsx